// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__q1BGr","arrow":"styles_arrow__3B3WY"};